import { Select, Text } from '@/components'
import { APIClient } from '@/services'
import { QuestionProps } from '../types'
import React from 'react'

export function LearningMotivations(props: QuestionProps) {
  const { form, disabled } = props
  const { options } = APIClient.Session.useSession()

  return (
    <>
      <Select
        {...form.register('learning_motivations')}
        options={options?.motivations}
        variants={['noError']}
        arrowIconName='chevron-right'
        disabled={disabled}
        label=''
        multiple
        HeaderComponent={() => (
        <Text
          variants={['h4', 'color:neutral5', 'paddingLeft:3', 'paddingTop:2', 'paddingBottom:1']}
          text="Select all that apply"
        />
      )}
      />
    </>
  )
}